<div class="background">
  <div class="layout" [class]="trigger">
    @for (row of rows; track $index) {
      <div class="carouselrow" [class]="row.class">
        @for (image of row.images; track $index) {
          <img [src]="image.url" [width]="image.width" [height]="rowHeight" loading="lazy" alt="Background image" />
        }
      </div>
    }
  </div>
</div>
